// And now load this bundle's actual entry point.
import("./jsalerts-config.js");
